import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=66fa72ea&scoped=true"
import script from "./verification.vue?vue&type=script&lang=js"
export * from "./verification.vue?vue&type=script&lang=js"
import style0 from "./verification.vue?vue&type=style&index=0&id=66fa72ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa72ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fa72ea')) {
      api.createRecord('66fa72ea', component.options)
    } else {
      api.reload('66fa72ea', component.options)
    }
    module.hot.accept("./verification.vue?vue&type=template&id=66fa72ea&scoped=true", function () {
      api.rerender('66fa72ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/verification.vue"
export default component.exports